import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PaypalWithdrawal.css";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";

// Icons
import btc from "../assets/btc.png";
import eth from "../assets/eth.png";
import bnb from "../assets/bnb.png";
import sol from "../assets/sol.png";
import xrp from "../assets/xrp.png";
import doge from "../assets/doge.png";
import ltc from "../assets/ltc.png";
import trx from "../assets/trx.png";
import usdt from "../assets/usdt.png";
import usdttether from "../assets/usdttether.png";

const API = "https://backend-safepal.onrender.com/api/transfer";

/* ================= COINS ================= */
const coins = [
  { key: "btc", label: "Bitcoin", symbol: "BTC", icon: btc },
  { key: "eth", label: "Ethereum", symbol: "ETH", icon: eth },
  { key: "bnb", label: "BNB", symbol: "BNB", icon: bnb },
  { key: "sol", label: "Solana", symbol: "SOL", icon: sol },
  { key: "xrp", label: "XRP", symbol: "XRP", icon: xrp },
  { key: "doge", label: "Dogecoin", symbol: "DOGE", icon: doge },
  { key: "ltc", label: "Litecoin", symbol: "LTC", icon: ltc },
  { key: "trx", label: "TRX", symbol: "TRX", icon: trx },
  { key: "usdtTron", label: "USDT-TRC20", symbol: "USDT-TRC20", icon: usdttether },
  { key: "usdtBnb", label: "USDT-BEP20", symbol: "USDT-BEP20", icon: usdt },
];

/* ================= STATIC PRICES (matching backend) ================= */
const STATIC_PRICES = {
  btc: 85966.43,
  eth: 2296.54,
  bnb: 596.78,
  sol: 172.45,
  xrp: 0.52,
  doge: 0.12,
  ltc: 81.34,
  trx: 0.104,
  usdtTron: 1.00,
  usdtBnb: 1.00
};

/* ================= FORMAT ================= */
const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloat = ({ 
  phoneNumber = "15485825756", 
  message = "Hello! I need urgent support from safepalPay customer service for PayPal withdrawal.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float-unique ${pulseEffect ? 'pulse-unique' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp for withdrawal support"
    >
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 32 32"
        fill="white"
      >
        <path d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.645.867 5.084 2.329 7.058L5 29l7.142-1.875A11.96 11.96 0 0016 27c6.627 0 12-5.373 12-11.999C28 8.373 22.627 3 16.001 3zm0 21.999c-1.924 0-3.715-.57-5.219-1.548l-.372-.23-4.242 1.114 1.133-4.135-.242-.384A9.957 9.957 0 016 15.001C6 9.486 10.486 5 16.001 5 21.515 5 26 9.486 26 15.001c0 5.514-4.485 9.998-9.999 9.998zm5.548-7.557c-.303-.151-1.793-.886-2.071-.987-.279-.101-.483-.151-.687.151-.202.302-.787.987-.965 1.19-.177.202-.354.227-.656.075-.303-.151-1.279-.471-2.435-1.5-.9-.802-1.508-1.792-1.686-2.094-.177-.303-.019-.467.133-.619.136-.135.303-.354.455-.531.152-.177.202-.303.303-.505.101-.202.051-.379-.025-.531-.076-.151-.687-1.656-.941-2.269-.247-.592-.498-.512-.687-.521-.177-.008-.379-.01-.582-.01-.202 0-.531.075-.808.379-.278.303-1.06 1.035-1.06 2.524 0 1.488 1.085 2.926 1.237 3.128.151.202 2.14 3.27 5.183 4.588.724.312 1.288.498 1.728.637.726.231 1.387.198 1.911.12.583-.087 1.793-.733 2.047-1.44.253-.707.253-1.313.177-1.44-.076-.126-.278-.198-.581-.354z" />
      </svg>
    </a>
  );
};

const PaypalWithdrawal = () => {
  const navigate = useNavigate();

  const [selectedCoin, setSelectedCoin] = useState(coins[0]);
  const [usdAmount, setUsdAmount] = useState("");
  const [coinAmount, setCoinAmount] = useState(0);
  const [price, setPrice] = useState(0);
  const [coinBalance, setCoinBalance] = useState(0);
  const [usdBalance, setUsdBalance] = useState(0);
  const [fullName, setFullName] = useState("");
  const [paypalEmail, setPaypalEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Crisp Chat Integration
  useEffect(() => {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = "b5635951-f13a-4b92-95d7-c1e3666f3abf";

    window.$crisp.push(["do", "chat:show"]);

    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:hide"]);
      }
    };
  }, []);

  // Pass user email to Crisp when available
  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");
    const userName = localStorage.getItem("userName");
    
    if (userEmail && window.$crisp) {
      window.$crisp.push(["set", "user:email", userEmail]);
      if (userName) {
        window.$crisp.push(["set", "user:nickname", userName]);
      }
    }
  }, []);

  /* ================= HELPER: Get CoinGecko ID ================= */
  const getCoinGeckoId = (coinKey) => {
    const map = {
      btc: "bitcoin",
      eth: "ethereum",
      bnb: "binancecoin",
      sol: "solana",
      xrp: "ripple",
      doge: "dogecoin",
      ltc: "litecoin",
      trx: "tron",
      usdtTron: "tether",
      usdtBnb: "tether",
    };
    return map[coinKey] || coinKey;
  };

  /* ================= FETCH PRICE FROM BACKEND FIRST ================= */
  const fetchPriceFromBackend = async (coinKey) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://backend-safepal.onrender.com/api/crypto/price/${coinKey}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (res.data.success) {
        return res.data.data.price;
      }
      return null;
    } catch (err) {
      console.log("Backend price fetch failed, falling back to CoinGecko");
      return null;
    }
  };

  /* ================= FETCH LIVE PRICE WITH FALLBACK ================= */
  const fetchLivePrice = async (coinKey) => {
    // First try backend
    const backendPrice = await fetchPriceFromBackend(coinKey);
    if (backendPrice) {
      return backendPrice;
    }

    // Fallback to CoinGecko
    try {
      const coinId = getCoinGeckoId(coinKey);
      const res = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price",
        { params: { ids: coinId, vs_currencies: "usd" } }
      );
      return res.data[coinId]?.usd || STATIC_PRICES[coinKey] || 0;
    } catch (err) {
      console.log("CoinGecko fetch failed, using static price");
      return STATIC_PRICES[coinKey] || 0;
    }
  };

  /* ================= FETCH BALANCE ================= */
  const fetchBalance = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) return;

      // Get balance from API
      const res = await axios.get(`${API}/balance`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const balances = res.data.data.walletBalances || {};
      const bal = balances[selectedCoin.key] || 0;
      
      setCoinBalance(bal);

      // Get price (prioritize backend)
      const currentPrice = await fetchLivePrice(selectedCoin.key);
      setPrice(currentPrice);
      setUsdBalance(bal * currentPrice);
      setError("");

    } catch (err) {
      console.error("Balance fetch error:", err);
      
      // Fallback to localStorage
      try {
        const savedProfile = localStorage.getItem("userProfile");
        if (savedProfile) {
          const profile = JSON.parse(savedProfile);
          if (profile.walletBalances && profile.walletBalances[selectedCoin.key]) {
            const bal = profile.walletBalances[selectedCoin.key];
            setCoinBalance(bal);
            
            const staticPrice = STATIC_PRICES[selectedCoin.key] || 0;
            setPrice(staticPrice);
            setUsdBalance(bal * staticPrice);
          }
        }
      } catch (e) {
        console.error("LocalStorage fallback error:", e);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, [selectedCoin]);

  /* ================= USD → COIN ================= */
  useEffect(() => {
    if (!usdAmount || !price) {
      setCoinAmount(0);
      return;
    }
    setCoinAmount(Number(usdAmount) / price);
  }, [usdAmount, price]);

  /* ================= CHECK BALANCE ================= */
  const hasInsufficientBalance = () => {
    if (!usdAmount || !coinAmount) return false;
    return coinAmount > coinBalance;
  };

  /* ================= HANDLE CONTINUE ================= */
  const handleContinue = async () => {
    // Clear previous error
    setError("");

    // Validate inputs
    if (!fullName.trim()) {
      setError("Please enter your full name");
      return;
    }

    if (!paypalEmail.trim()) {
      setError("Please enter your PayPal email");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(paypalEmail)) {
      setError("Please enter a valid email address");
      return;
    }

    if (!usdAmount || Number(usdAmount) <= 0) {
      setError("Please enter a valid amount");
      return;
    }

    // Check balance
    if (hasInsufficientBalance()) {
      setError(`Insufficient ${selectedCoin.symbol} balance. You have ${coinBalance.toFixed(8)} ${selectedCoin.symbol} available.`);
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const response = await axios.post(
        "https://backend-safepal.onrender.com/api/paypal/initiate",
        {
          asset: selectedCoin.key,
          amount: coinAmount,
          usdAmount: Number(usdAmount),
          paypalEmail: paypalEmail,
          fullName: fullName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        navigate("/paypalwithdrawalotp", {
          state: {
            asset: selectedCoin.key,
            amount: coinAmount,
            usdAmount: Number(usdAmount),
            paypalEmail,
            fullName,
            price: price,
            transferId: response.data.data?.transferId
          },
        });
      } else {
        setError(response.data.message || "Failed to initiate withdrawal");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.error || "Failed to initiate withdrawal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="pw-paypal-withdrawal-page-unique">
        <div className="pw-paypal-withdrawal-card-unique">
          <span className="pw-paypal-back-unique" onClick={() => navigate(-1)}>←</span>

          <div className="pw-paypal-withdrawal-logo-unique">
            <img src={logo} alt="SafepalPay" />
          </div>

          <h2 className="pw-paypal-withdrawal-title-unique">PayPal Withdrawal</h2>

          {error && (
            <div className="pw-paypal-withdrawal-error-unique">
              {error}
            </div>
          )}

          <div className="pw-paypal-withdrawal-form-group-unique">
            <label>Full Name</label>
            <input 
              type="text" 
              placeholder="Enter your full name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="pw-paypal-withdrawal-form-group-unique">
            <label>PayPal Email Address</label>
            <input 
              type="email" 
              placeholder="Enter email address"
              value={paypalEmail}
              onChange={(e) => setPaypalEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="pw-paypal-withdrawal-form-group-unique">
            <label>Select Crypto</label>
            <div className="pw-paypal-input-with-icon-unique">
              <img src={selectedCoin.icon} alt={selectedCoin.symbol} />
              <span className="pw-paypal-coin-symbol-unique">
                {selectedCoin.symbol}
              </span>
              <select
                value={selectedCoin.key}
                onChange={(e) =>
                  setSelectedCoin(
                    coins.find((c) => c.key === e.target.value)
                  )
                }
                disabled={loading}
              >
                {coins.map((coin) => (
                  <option key={coin.key} value={coin.key}>
                    {coin.symbol} - {coin.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="pw-paypal-withdrawal-form-group-unique">
            <label>Amount (USD)</label>
            <div className="pw-paypal-input-with-icon-unique">
              <span className="pw-paypal-input-text-unique">$</span>
              <input
                type="number"
                value={usdAmount}
                onChange={(e) => setUsdAmount(e.target.value)}
                placeholder="Enter amount in USD"
                disabled={loading}
              />
            </div>
            <small>
              ≈ {coinAmount.toFixed(8)} {selectedCoin.symbol}
            </small>
          </div>

          <div className="pw-paypal-withdrawal-info-row-unique">
            <span>Available</span>
            <div className="pw-paypal-withdrawal-balance-coin-unique">
              <img src={selectedCoin.icon} alt={selectedCoin.symbol} />
              <span>
                {coinBalance.toFixed(8)} {selectedCoin.symbol}
              </span>
            </div>
          </div>

          {/* Show USD balance */}
          <div className="pw-paypal-withdrawal-info-row-unique" style={{ marginTop: "5px", fontSize: "12px", color: "#666" }}>
            <span></span>
            <span>{formatCurrency(usdBalance)} USD</span>
          </div>

          {hasInsufficientBalance() && (
            <div className="pw-paypal-withdrawal-insufficient-warning-unique">
              Insufficient balance. You have {coinBalance.toFixed(8)} {selectedCoin.symbol} ({formatCurrency(usdBalance)}) available.
            </div>
          )}

          <button
            className={`pw-paypal-withdrawal-btn-unique ${loading ? 'loading-unique' : ''}`}
            onClick={handleContinue}
            disabled={loading || hasInsufficientBalance()}
          >
            {loading ? "Processing..." : "Continue"}
          </button>

        </div>
      </div>

      {/* WhatsApp Float Button - For PayPal Withdrawal Support */}
      <WhatsAppFloat 
        phoneNumber="15485825756"
        message="Hello! I need urgent support from safepalPay customer service for PayPal withdrawal."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
        size="54px"
        iconSize="28px"
      />
    </>
  );
};

export default PaypalWithdrawal;